import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useRestaurantAuth } from '../context/RestaurantAuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRestaurantRoute() {
  const { hotelId, restaurantId } = useParams<{ hotelId: string; restaurantId: string }>();
  const { isAuthenticated, isLoading } = useRestaurantAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
          <p className="text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/restaurant/${hotelId}/${restaurantId}/login`} replace />;
  }

  return <Outlet />;
}
